/* tslint:disable */
/* eslint-disable */
/**
 * Orders and payments
 * Placeholder description of the order & payment instruction service. Detailed description to be provided by Monavate team.
 *
 * The version of the OpenAPI document: 1.33.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { NotFoundError } from '../models';
// @ts-ignore
import type { Order } from '../models';
// @ts-ignore
import type { OrderRequest } from '../models';
// @ts-ignore
import type { Orders } from '../models';
// @ts-ignore
import type { SearchOrderRequest } from '../models';
// @ts-ignore
import type { SearchOrderResponse } from '../models';
// @ts-ignore
import type { ValidationError } from '../models';
/**
 * OrdersApi - axios parameter creator
 * @export
 */
export const OrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancels an order
         * @summary Cancel order
         * @param {string} orderReference Order reference in an external system, defined by the client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder: async (orderReference: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderReference' is not null or undefined
            assertParamExists('cancelOrder', 'orderReference', orderReference)
            const localVarPath = `/orders/{order-reference}`
                .replace(`{${"order-reference"}}`, encodeURIComponent(String(orderReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new Order...
         * @summary Create order
         * @param {OrderRequest} orderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrder: async (orderRequest: OrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderRequest' is not null or undefined
            assertParamExists('createOrder', 'orderRequest', orderRequest)
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the details of the specified order.
         * @summary View order
         * @param {string} orderReference Order reference in an external system, defined by the client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder: async (orderReference: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderReference' is not null or undefined
            assertParamExists('getOrder', 'orderReference', orderReference)
            const localVarPath = `/orders/{order-reference}`
                .replace(`{${"order-reference"}}`, encodeURIComponent(String(orderReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of your orders. Can be filtered.
         * @summary View orders list
         * @param {string} [reference] Filter by a reference number.
         * @param {string} [paymentId] Filter by a payment ID.
         * @param {string} [costCentre] Filter by a cost center name or ID.
         * @param {string} [customerName] Filter by a customer name.
         * @param {string} [customerReference] Filter by a customer reference number.
         * @param {string} [createdBy] Filter by a user who created the order.
         * @param {string} [createdAtFrom] Lower boundary for filtering by creation date.
         * @param {string} [createdAtTo] Higher boundary for filtering by creation date.
         * @param {boolean} [isCompleted] Filter by an order completion.
         * @param {number} [pageNumber] Page number for pagination.
         * @param {number} [pageSize] Page size for pagination.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders: async (reference?: string, paymentId?: string, costCentre?: string, customerName?: string, customerReference?: string, createdBy?: string, createdAtFrom?: string, createdAtTo?: string, isCompleted?: boolean, pageNumber?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reference !== undefined) {
                localVarQueryParameter['reference'] = reference;
            }

            if (paymentId !== undefined) {
                localVarQueryParameter['paymentId'] = paymentId;
            }

            if (costCentre !== undefined) {
                localVarQueryParameter['costCentre'] = costCentre;
            }

            if (customerName !== undefined) {
                localVarQueryParameter['customerName'] = customerName;
            }

            if (customerReference !== undefined) {
                localVarQueryParameter['customerReference'] = customerReference;
            }

            if (createdBy !== undefined) {
                localVarQueryParameter['createdBy'] = createdBy;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['createdAtFrom'] = (createdAtFrom as any instanceof Date) ?
                    (createdAtFrom as any).toISOString() :
                    createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['createdAtTo'] = (createdAtTo as any instanceof Date) ?
                    (createdAtTo as any).toISOString() :
                    createdAtTo;
            }

            if (isCompleted !== undefined) {
                localVarQueryParameter['isCompleted'] = isCompleted;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifies an order
         * @summary Modify order
         * @param {OrderRequest} orderRequest 
         * @param {string} orderReference Order reference in an external system, defined by the client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyOrder: async (orderRequest: OrderRequest, orderReference: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderRequest' is not null or undefined
            assertParamExists('modifyOrder', 'orderRequest', orderRequest)
            // verify required parameter 'orderReference' is not null or undefined
            assertParamExists('modifyOrder', 'orderReference', orderReference)
            const localVarPath = `/orders/{order-reference}`
                .replace(`{${"order-reference"}}`, encodeURIComponent(String(orderReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search orders by reference, payment ID, transaction ID, acquirer reference, or card ID.  A partial search is possible with a \'starts with\' match.
         * @summary Search order
         * @param {SearchOrderRequest} searchOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrder: async (searchOrderRequest: SearchOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchOrderRequest' is not null or undefined
            assertParamExists('searchOrder', 'searchOrderRequest', searchOrderRequest)
            const localVarPath = `/orders/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrdersApi - functional programming interface
 * @export
 */
export const OrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancels an order
         * @summary Cancel order
         * @param {string} orderReference Order reference in an external system, defined by the client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrder(orderReference: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrder(orderReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.cancelOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new Order...
         * @summary Create order
         * @param {OrderRequest} orderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrder(orderRequest: OrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrder(orderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.createOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the details of the specified order.
         * @summary View order
         * @param {string} orderReference Order reference in an external system, defined by the client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrder(orderReference: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrder(orderReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of your orders. Can be filtered.
         * @summary View orders list
         * @param {string} [reference] Filter by a reference number.
         * @param {string} [paymentId] Filter by a payment ID.
         * @param {string} [costCentre] Filter by a cost center name or ID.
         * @param {string} [customerName] Filter by a customer name.
         * @param {string} [customerReference] Filter by a customer reference number.
         * @param {string} [createdBy] Filter by a user who created the order.
         * @param {string} [createdAtFrom] Lower boundary for filtering by creation date.
         * @param {string} [createdAtTo] Higher boundary for filtering by creation date.
         * @param {boolean} [isCompleted] Filter by an order completion.
         * @param {number} [pageNumber] Page number for pagination.
         * @param {number} [pageSize] Page size for pagination.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrders(reference?: string, paymentId?: string, costCentre?: string, customerName?: string, customerReference?: string, createdBy?: string, createdAtFrom?: string, createdAtTo?: string, isCompleted?: boolean, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Orders>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrders(reference, paymentId, costCentre, customerName, customerReference, createdBy, createdAtFrom, createdAtTo, isCompleted, pageNumber, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modifies an order
         * @summary Modify order
         * @param {OrderRequest} orderRequest 
         * @param {string} orderReference Order reference in an external system, defined by the client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modifyOrder(orderRequest: OrderRequest, orderReference: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modifyOrder(orderRequest, orderReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.modifyOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search orders by reference, payment ID, transaction ID, acquirer reference, or card ID.  A partial search is possible with a \'starts with\' match.
         * @summary Search order
         * @param {SearchOrderRequest} searchOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchOrder(searchOrderRequest: SearchOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchOrderResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchOrder(searchOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.searchOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrdersApi - factory interface
 * @export
 */
export const OrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrdersApiFp(configuration)
    return {
        /**
         * Cancels an order
         * @summary Cancel order
         * @param {OrdersApiCancelOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder(requestParameters: OrdersApiCancelOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<Order> {
            return localVarFp.cancelOrder(requestParameters.orderReference, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new Order...
         * @summary Create order
         * @param {OrdersApiCreateOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrder(requestParameters: OrdersApiCreateOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<Order> {
            return localVarFp.createOrder(requestParameters.orderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the details of the specified order.
         * @summary View order
         * @param {OrdersApiGetOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder(requestParameters: OrdersApiGetOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<Order> {
            return localVarFp.getOrder(requestParameters.orderReference, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of your orders. Can be filtered.
         * @summary View orders list
         * @param {OrdersApiGetOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders(requestParameters: OrdersApiGetOrdersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Orders> {
            return localVarFp.getOrders(requestParameters.reference, requestParameters.paymentId, requestParameters.costCentre, requestParameters.customerName, requestParameters.customerReference, requestParameters.createdBy, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.isCompleted, requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Modifies an order
         * @summary Modify order
         * @param {OrdersApiModifyOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyOrder(requestParameters: OrdersApiModifyOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<Order> {
            return localVarFp.modifyOrder(requestParameters.orderRequest, requestParameters.orderReference, options).then((request) => request(axios, basePath));
        },
        /**
         * Search orders by reference, payment ID, transaction ID, acquirer reference, or card ID.  A partial search is possible with a \'starts with\' match.
         * @summary Search order
         * @param {OrdersApiSearchOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrder(requestParameters: OrdersApiSearchOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SearchOrderResponse>> {
            return localVarFp.searchOrder(requestParameters.searchOrderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cancelOrder operation in OrdersApi.
 * @export
 * @interface OrdersApiCancelOrderRequest
 */
export interface OrdersApiCancelOrderRequest {
    /**
     * Order reference in an external system, defined by the client.
     * @type {string}
     * @memberof OrdersApiCancelOrder
     */
    readonly orderReference: string
}

/**
 * Request parameters for createOrder operation in OrdersApi.
 * @export
 * @interface OrdersApiCreateOrderRequest
 */
export interface OrdersApiCreateOrderRequest {
    /**
     * 
     * @type {OrderRequest}
     * @memberof OrdersApiCreateOrder
     */
    readonly orderRequest: OrderRequest
}

/**
 * Request parameters for getOrder operation in OrdersApi.
 * @export
 * @interface OrdersApiGetOrderRequest
 */
export interface OrdersApiGetOrderRequest {
    /**
     * Order reference in an external system, defined by the client.
     * @type {string}
     * @memberof OrdersApiGetOrder
     */
    readonly orderReference: string
}

/**
 * Request parameters for getOrders operation in OrdersApi.
 * @export
 * @interface OrdersApiGetOrdersRequest
 */
export interface OrdersApiGetOrdersRequest {
    /**
     * Filter by a reference number.
     * @type {string}
     * @memberof OrdersApiGetOrders
     */
    readonly reference?: string

    /**
     * Filter by a payment ID.
     * @type {string}
     * @memberof OrdersApiGetOrders
     */
    readonly paymentId?: string

    /**
     * Filter by a cost center name or ID.
     * @type {string}
     * @memberof OrdersApiGetOrders
     */
    readonly costCentre?: string

    /**
     * Filter by a customer name.
     * @type {string}
     * @memberof OrdersApiGetOrders
     */
    readonly customerName?: string

    /**
     * Filter by a customer reference number.
     * @type {string}
     * @memberof OrdersApiGetOrders
     */
    readonly customerReference?: string

    /**
     * Filter by a user who created the order.
     * @type {string}
     * @memberof OrdersApiGetOrders
     */
    readonly createdBy?: string

    /**
     * Lower boundary for filtering by creation date.
     * @type {string}
     * @memberof OrdersApiGetOrders
     */
    readonly createdAtFrom?: string

    /**
     * Higher boundary for filtering by creation date.
     * @type {string}
     * @memberof OrdersApiGetOrders
     */
    readonly createdAtTo?: string

    /**
     * Filter by an order completion.
     * @type {boolean}
     * @memberof OrdersApiGetOrders
     */
    readonly isCompleted?: boolean

    /**
     * Page number for pagination.
     * @type {number}
     * @memberof OrdersApiGetOrders
     */
    readonly pageNumber?: number

    /**
     * Page size for pagination.
     * @type {number}
     * @memberof OrdersApiGetOrders
     */
    readonly pageSize?: number
}

/**
 * Request parameters for modifyOrder operation in OrdersApi.
 * @export
 * @interface OrdersApiModifyOrderRequest
 */
export interface OrdersApiModifyOrderRequest {
    /**
     * 
     * @type {OrderRequest}
     * @memberof OrdersApiModifyOrder
     */
    readonly orderRequest: OrderRequest

    /**
     * Order reference in an external system, defined by the client.
     * @type {string}
     * @memberof OrdersApiModifyOrder
     */
    readonly orderReference: string
}

/**
 * Request parameters for searchOrder operation in OrdersApi.
 * @export
 * @interface OrdersApiSearchOrderRequest
 */
export interface OrdersApiSearchOrderRequest {
    /**
     * 
     * @type {SearchOrderRequest}
     * @memberof OrdersApiSearchOrder
     */
    readonly searchOrderRequest: SearchOrderRequest
}

/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
export class OrdersApi extends BaseAPI {
    /**
     * Cancels an order
     * @summary Cancel order
     * @param {OrdersApiCancelOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public cancelOrder(requestParameters: OrdersApiCancelOrderRequest, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).cancelOrder(requestParameters.orderReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new Order...
     * @summary Create order
     * @param {OrdersApiCreateOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public createOrder(requestParameters: OrdersApiCreateOrderRequest, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).createOrder(requestParameters.orderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the details of the specified order.
     * @summary View order
     * @param {OrdersApiGetOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public getOrder(requestParameters: OrdersApiGetOrderRequest, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).getOrder(requestParameters.orderReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of your orders. Can be filtered.
     * @summary View orders list
     * @param {OrdersApiGetOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public getOrders(requestParameters: OrdersApiGetOrdersRequest = {}, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).getOrders(requestParameters.reference, requestParameters.paymentId, requestParameters.costCentre, requestParameters.customerName, requestParameters.customerReference, requestParameters.createdBy, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.isCompleted, requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Modifies an order
     * @summary Modify order
     * @param {OrdersApiModifyOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public modifyOrder(requestParameters: OrdersApiModifyOrderRequest, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).modifyOrder(requestParameters.orderRequest, requestParameters.orderReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search orders by reference, payment ID, transaction ID, acquirer reference, or card ID.  A partial search is possible with a \'starts with\' match.
     * @summary Search order
     * @param {OrdersApiSearchOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public searchOrder(requestParameters: OrdersApiSearchOrderRequest, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).searchOrder(requestParameters.searchOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

